import { AddToDashboardButton } from "app/components/React/AddToDashboard/AddToDashboardButton";
import { useState } from "react";
import { allTrackers } from "app/services/track/track";
import { AddToDashboardModalV2 } from "pro-features/components/Modals/src/AddToDashboardModal-v2";
import { WidgetModelAdapterService } from "app/components/widget/WidgetModelAdapterService";

export const AddToDashboard = ({
    metric,
    webSource,
    filters,
    overrideParams = {},
    isDisabled = false,
    tooltipContent = null,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const getCustomModel = () => {
        const model = WidgetModelAdapterService.getInstance().fromWebsite(
            metric.addToDashboardName,
            metric.chartType ? metric.chartType : "Graph",
            webSource,
            undefined,
            filters,
        );

        return {
            ...model,
            ...overrideParams,
        };
    };
    function onConfirm() {
        setIsOpen(false);
    }

    function handleClose() {
        setIsOpen(false);
    }

    function handleOpenDashboard() {
        allTrackers.trackEvent("Pop up", "open", `Add to my Dashboard/${metric.title}`);
        setIsOpen(true);
    }

    return (
        <>
            <AddToDashboardButton
                onClick={handleOpenDashboard}
                isDisabled={isDisabled}
                tooltipContent={tooltipContent}
            />
            {isOpen && (
                <AddToDashboardModalV2
                    customModel={getCustomModel()}
                    onConfirm={onConfirm}
                    onCancel={handleClose}
                />
            )}
        </>
    );
};
